import React from 'react';
import { TextMessage } from './TextMessage';
import './TextMessage.css';

// New component to display a conversation between specific people
export const TextConversation = ({ messages, title = "Text Messages" }) => {
  if (!messages || messages.length === 0) return null;
  
  // Get unique senders in the conversation
  const uniqueSenders = [...new Set(messages.map(msg => msg.sender))];
  
  // For a better visual representation, we'll alternate colors between senders
  // First identify if we have multiple senders in this conversation
  const mainCharacter = uniqueSenders.length > 1 
    ? uniqueSenders[0] // If multiple senders, use the first one as main
    : ""; // If only one sender, use empty string (all messages will be incoming)
  
  return (
    <div className="text-messages-section">
      {messages.map((message, idx) => (
        <TextMessage 
          key={`msg-${idx}`} 
          message={message} 
          mainCharacter={mainCharacter}
        />
      ))}
      <div className="clearfix"></div>
    </div>
  );
}; 